import GoogleMapReact from "google-map-react";
import React from "react";
import MapMarker from "../../../../../../components/MapMarker";

interface IAddressMapProps {
  center?: { lat: number; lng: number };
  formatted_address?: string;
  zoom?: number;
}

const AddressMap = (props: IAddressMapProps) => {
  const center = props.center ?? {
    lat: 40.1297,
    lng: -8.2127619,
  };
  const zoom = props.zoom ?? 6;

  return (
    <div
      style={{
        height: "100%",
        width: "100%",
        position: "relative",
        boxShadow: "0.25rem 0.25rem 0.75rem 0.25rem rgba(0,0,0,.15)",
      }}
    >
      <GoogleMapReact
        center={center}
        zoom={zoom}
        yesIWantToUseGoogleMapApiInternals
        onGoogleApiLoaded={({ map, maps }) => {
          map.data.setStyle({ clickable: false });
        }}
        style={{
          height: "24rem",
        }}
        options={(maps) => {
          return {
            zoomControl: false,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
          };
        }}
      >
        {props.center?.lat && props.center?.lng && (
          <MapMarker
            key={`map-Marker`}
            lat={props.center.lat}
            lng={props.center.lng}
            label={props.formatted_address ?? ""}
          />
        )}
      </GoogleMapReact>
    </div>
  );
};

export default AddressMap;
